export default {
    remove: 'Supprimer',
    save: 'Enregistrer',
    cancel: 'Annuler',
    loading: 'Chargement…',
    value: 'Valeur',
    'action-bar.collapse': 'Réduire',
    'action-bar.expand': 'Développer',
    'action-bar.actions': 'Actions',
    'callout.note': 'Note',
    'callout.important': 'Important',
    'callout.tip': 'Conseil',
    'callout.caution': 'Prudence',
    'callout.warning': 'Avertissement',
    'collapsible-section.open': 'Ouvrir la section { header }',
    'collapsible-section.close': 'Fermer la section { header }',
    'date-picker.today': "Aujourd'hui",
    'date-picker.month.heading': 'Mois',
    'date-picker.quarter.heading': 'Trimestre',
    'date-picker.year.heading': 'Année',
    'chip-set.clear-all': 'Tout effacer',
    'snackbar.dismiss': 'Fermer',
    'file.drag-and-drop-tips':
        'Glissez-déposez votre fichier ici, ou cliquez pour parcourir.',
    'file-viewer.message.unsupported-filetype':
        "Impossible d'afficher un aperçu pour ce type de fichier.",
    'file-viewer.message.try-other-options':
        'Téléchargez le fichier ou ouvrez-le dans un nouvel onglet.',
    'file-viewer.download': 'Télécharger',
    'file-viewer.exit-fullscreen': 'Quitter le mode plein écran',
    'file-viewer.open-in-fullscreen': 'Ouvrir en plein écran',
    'file-viewer.open-in-new-tab': 'Ouvrir dans un nouvel onglet',
    'file-viewer.more-actions': 'Plus…',
    'editor-menu.bold': 'Gras',
    'editor-menu.italic': 'Italique',
    'editor-menu.strikethrough': 'Barré',
    'editor-menu.h1': 'Titre 1',
    'editor-menu.h2': 'Titre 2',
    'editor-menu.h3': 'Titre 3',
    'editor-menu.bulleted-list': 'Liste à puces',
    'editor-menu.numbered-list': 'Liste numérotée',
    'editor-menu.blockquote': 'Bloc de citation',
    'editor-menu.link': 'Lien',
    'editor-link-menu.text': 'Texte',
    'editor-link-menu.link': 'Lien',
    'editor-menu.code-block': 'Bloc de code',
    'editor-menu.code': 'Code',
    'editor-image-view.loading': "Chargement de l'image: { filename }...",
    'editor-image-view.failed':
        "Un problème est survenu avec l'image: { filename }",
    'editor-image-view.success': 'Image: { filename } est prête',
    'editor-image-view.resize-handle':
        "Faites glisser vers la droite ou la gauche pour redimensionner l'image",
    'progress-bar': 'Barre de progression',
    'ai-avatar.label': 'Avatar IA',
    'ai-avatar.thinking': 'en réflexion',
    'table.select-all': 'Sélectionner toutes les lignes',
    'table.select-row': 'Sélectionner cette ligne',
    'profile-picture.remove': 'Supprimer l’image sélectionnée',
    'profile-picture.unsupported-preview.title':
        "Format d'image non pris en charge",
    'profile-picture.unsupported-preview.description':
        "Nous ne pouvons pas afficher l'image sélectionnée dans ce navigateur. Veuillez sélectionner un autre fichier image.",
};
